module.exports = __webpack_public_path__ + "static/media/Pancham_gaussian2.5af96fec.png";